// Si la versión instalada debe actualizarse y si el aviso se muestra. Puro, sin
// imports, para poder probarlo sin la app (lib/versionApp.test.mjs).

// "Después" esconde el aviso seis horas: lo bastante para terminar el servicio,
// no tanto como para olvidarse.
export const POSPONER_MS = 6 * 60 * 60 * 1000;

/**
 * instalada:  versionCode del APK que corre (número).
 * manifiesto: { ultima: { versionCode, … } | null, obligatoriaDesde: número | null }
 * pospuesta:  { versionCode, hasta } guardado al tocar "Después", o null.
 */
export function evaluarVersion({ instalada, manifiesto, pospuesta = null, ahora = Date.now() }) {
  const ultima = manifiesto?.ultima;
  if (!ultima || !Number.isFinite(instalada) || !(ultima.versionCode > instalada)) {
    return { hay: false, obligatoria: false, mostrar: false };
  }
  const desde = manifiesto.obligatoriaDesde;
  const obligatoria = Number.isFinite(desde) && instalada < desde;
  // Posponer vale solo para ESA versión: si sale otra más nueva, se avisa
  const pospuestaVigente = pospuesta?.versionCode === ultima.versionCode && pospuesta.hasta > ahora;
  return { hay: true, obligatoria, mostrar: obligatoria || !pospuestaVigente };
}

export const megas = (bytes) => `${Math.max(1, Math.round((Number(bytes) || 0) / 1e6))} MB`;
